export default {
  experimentId: '3',
  serverUrl: 'https://magpie-cogsciprag.fly.dev//',
  socketUrl: 'wss://magpie-cogsciprag.fly.dev//socket',
  // this will be used in prolific mode
  completionUrl: 'none',
  contactEmail: 'michael.franke@uni-tuebingen.de',
  // Either 'debug', 'directLink' or 'prolific'
  mode: 'directLink',
  language: 'en'
};


